import mensagens from './mensagens';
import {
	DadosGraficoVariaveis,
	DadosSerieVariavelMeteorologica,
	SerieVariavelMeteorologica,
} from './serie-variavel-meteorologica';
export interface DadosRadiacaoSolar extends DadosGraficoVariaveis {
	radiacao: number[];
}

export class SerieRadiacaoSolar extends SerieVariavelMeteorologica {
	private corRadiacao = '#FCC751';
	private readonly MAX_RADIACAO = 1200;

	constructor() {
		super();
	}

	obterDadosSerie(
		dados: DadosRadiacaoSolar,
		indexEixo: number
	): DadosSerieVariavelMeteorologica {
		const maxDados = dados.radiacao
			.filter(val => val !== null && val !== undefined)
			.reduce((max, val) => Math.max(max, val), 0);

		// Usa o menor valor entre o máximo dos dados e o máximo físico
		const softMax = Math.min(this.MAX_RADIACAO, maxDados * 1.2); // +20% de margem
		return {
			serie: [
				{
					yAxis: indexEixo,
					name: mensagens['variavel.radiacaoSolar'],
					type: 'line',
					data: this.prepararSerie(dados.datas, dados.radiacao),
					color: this.corRadiacao,
					tooltip: {
						valueDecimals: 2,
						valueSuffix: ` ${mensagens['variavel.radiacaoSolar.unidade']}`,
					},
				},
			],
			eixo: {
				title: {
					text: mensagens['variavel.radiacaoSolar.titulo-meteograma'],
				},
				lineWidth: 2,
				opposite: false,
				minRange: 200,
				labels: { align: 'left', x: 3 },
				min: 0,
				softMax: softMax,
			},
		};
	}
}
